import type { IPropertyBag } from '@deity-io/di-data-basics';
import { Input, Select } from '@deity-io/portal-ui';
import { CircularProgress } from '@mui/material';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetModelsByPackageVersionQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

interface StructurePickerProps {
  packageVersionUuid: string;
  locked?: boolean;
  selectedValue?: string;
  label?: string;
  helperText?: string;
  onChange?: (val: string, schema: IPropertyBag) => void;
  limit?: number;
  disableClearable?: boolean;
}
const StructurePicker: FC<StructurePickerProps> = ({
  locked,
  selectedValue,
  onChange,
  helperText,
  packageVersionUuid,
  label = 'Structure',
  limit = 500,
  disableClearable = true
}) => {
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const { data, loading } = useGetModelsByPackageVersionQuery(
    CACHE_FIRST && {
      variables: {
        offset: 0,
        limit,
        packageVersionUuid
      },
      skip: !packageVersionUuid
    }
  );

  return (
    <Select
      label={label}
      sx={{ marginY: 2, flex: 1 }}
      helperText={helperText}
      onChange={(val: any) => {
        if (onChange) {
          onChange(val.value, val.schema);
        }
      }}
      options={(data?.getModelsByPackageVersion.data || []).map(model => ({
        value: model.uuid,
        label: model.name,
        schema: model.schema
      }))}
      value={{
        label: data?.getModelsByPackageVersion.data.filter(model => model.uuid === selectedValue)[0]?.name || '',
        value: selectedValue || ''
      }}
      loading={loading}
      renderInput={p => (
        <Input
          {...p}
          label={label}
          InputProps={{
            ...p.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {p.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
      disabled={locked}
      disableClearable={disableClearable}
    />
  );
};
export default StructurePicker;
